import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const RegistrationEditor = React.lazy(() => import("@mediaspace/features/registration-editor"));

export const render = getStandaloneComponentRenderer(RegistrationEditor);
